// removed by extract-text-webpack-plugin
module.exports = {"white":"#ffffff","dark-red":"#a30000","suggestionBoxForm":"_3FrN8cUL4QUWJmqgO5uHrT","formsView":"VvvbtVT-u7xUdiKyXT7D2","topWrapper":"_3xIqpsmYlgAdMIZ-NLqdSl","formFieldsWrapper":"_32w-Bvc5L1A99yo5e5lWoY","bottomWrapper":"_36tGuIjhxWGrOe3BmL0oAx","writeIllustration":"bc9h4LnzUD58eAG1oX4ZR","successMessage":"_29-kIav4EJ5_6If-Na-BEM","onFocus":"_2XZ52W_b0zk5BmqtXJu_Nq","successMessageView":"_2tSwVYhpkF1Y07DyQCcmnd","hasSubmitted":"_2EiUTmIzFP7pVdFP73ghLp"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Form/SuggestionBoxForm/SuggestionBoxForm.css
// module id = 1328
// module chunks = 0